import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Checkbox } from "react-md";
import { cloneDeep, set } from "lodash";
import { RegistrationShape } from "../../../utils";

const validate = ranges => {
  let isValid = true;
  let error = null;

  if (ranges && (!ranges.pistol && !ranges.rifle)) {
    error = "Check at least one range";
    isValid = false;
  }

  return {
    isValid,
    error
  };
};

class EditRegistration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ranges: {
        pistol: props.editQueueItem.ranges.pistol,
        rifle: props.editQueueItem.ranges.rifle
      },
      error: null
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleChange(field, value) {
    this.setState(prevState => {
      const newState = cloneDeep(prevState);
      set(newState, field, value);
      const { error } = validate(newState.ranges);
      newState.error = error;

      return newState;
    });
  }

  handleSave() {
    const { onSave, rangeLocation, editQueueItem } = this.props;
    onSave(rangeLocation, editQueueItem.registrationId, {
      ranges: this.state.ranges
    });
  }

  render() {
    return (
      <div className="md-grid">
        <h6 className="md-cell md-cell--12 md-title">Pick Range(s) Type:</h6>
        <div className="md-cell md-cell--12">
          <div className="md-grid md-grid--no-spacing">
            <Checkbox
              id="pistol"
              name="pistol"
              label="Handgun"
              defaultChecked={this.state.ranges.pistol}
              value={this.state.ranges.pistol}
              onChange={value => this.handleChange("ranges.pistol", value)}
            />
            <Checkbox
              id="rifle"
              name="rifle"
              label="Rifle"
              defaultChecked={this.state.ranges.rifle}
              value={this.state.ranges.rifle}
              onChange={value => this.handleChange("ranges.rifle", value)}
            />
          </div>
        </div>
        {this.state.error &&
          <div className="md-cell md-cell--12" style={{ color: "#B71C1C" }}>
            {this.state.error}
          </div>}
        <div className="md-cell md-cell--12">
          <Button
            primary
            raised
            label="Save"
            onClick={this.handleSave}
            disabled={!!this.state.error}
          />
        </div>
      </div>
    );
  }
}

EditRegistration.propTypes = {
  onSave: PropTypes.func.isRequired,
  rangeLocation: PropTypes.string.isRequired,
  editQueueItem: RegistrationShape
};

EditRegistration.defaultProps = {
  editQueueItem: null
};

export default EditRegistration;



// WEBPACK FOOTER //
// ./src/staff/components/QueueItemDrawer/EditRegistration/EditRegistration.jsx